const clone = obj => JSON.parse(JSON.stringify(obj));
// sessionStorage
const ssSet = (key, value) => sessionStorage.setItem(key, value);
const ssGet = key => sessionStorage.getItem(key);
const ssRemove = key => sessionStorage.removeItem(key);
// localStorage
const lcSet = (key, value) => localStorage.setItem(key, value);
const lcGet = key => localStorage.getItem(key);
const lcRemove = key => localStorage.removeItem(key);

const lcSetWithAge = (key, value, age) => {
    let obj = {
        data: value,
        time: Date.now(), // 当前时间戳
        maxAge: age, // 过期时间
    };
    lcSet(key, JSON.stringify(obj))
};
const lcGetWithAge = (key) => {
    if (!lcGet(key)) {
        return undefined
    }
    if(lcGet(key).indexOf('data') === -1 ||
        lcGet(key).indexOf('time') === -1 ||
        lcGet(key).indexOf('maxAge') === -1) {
        return undefined
    }
    const {data, time, maxAge} = JSON.parse(lcGet(key));
    if (time + maxAge < Date.now()) {
        lcRemove(key);
        return undefined
    }
    return data
};

const compare = (val1, val2) => {
    return val1 - val2
};
const formatTime = date => {
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()
    const hour = date.getHours()
    const minute = date.getMinutes()
    const second = date.getSeconds()

    let time1 = `${[year, month, day].map(formatNumber).join('-')}`;
    let time2 = `${[hour, minute, second].map(formatNumber).join(':')}`;
    let time3 = `${[year, month, day].map(formatNumber).join('-')} ${[hour, minute, second].map(formatNumber).join(':')}`;
    let time4 = `${[year, month].map(formatNumber).join('-')}`;
    return {
        time1: time1,
        time2: time2,
        time3: time3,
        time4: time4
    }
};
const formatNumber = n => {
    n = n.toString();
    return n[1] ? n : `0${n}`
};
export {
    clone,
    ssSet,
    ssGet,
    ssRemove,
    lcSet,
    lcGet,
    lcSetWithAge,
    lcGetWithAge,

    lcRemove,
    compare,
    formatTime
};